export default{

}



// WEBPACK FOOTER //
// ./src/components/bank/store/actions.js